import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row g-0" }
const _hoisted_2 = { class: "col-6 stats-total-tile stats-total-tile--active border-end-subtle" }
const _hoisted_3 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_4 = { class: "stats-total-label" }
const _hoisted_5 = { class: "stats-total-age" }
const _hoisted_6 = { class: "stats-total-value mt-2" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "stats-total-unit" }
const _hoisted_10 = { class: "col-6 stats-total-tile stats-total-tile--reactive" }
const _hoisted_11 = { class: "d-flex justify-content-between align-items-start" }
const _hoisted_12 = { class: "stats-total-label" }
const _hoisted_13 = { class: "stats-total-age" }
const _hoisted_14 = { class: "stats-total-value mt-2" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "stats-total-unit" }
const _hoisted_18 = { class: "row g-0 stats-periods-border-top" }
const _hoisted_19 = { class: "d-flex justify-content-between align-items-center h-100" }
const _hoisted_20 = { class: "measurement-name" }
const _hoisted_21 = { class: "measurement-date" }
const _hoisted_22 = { class: "unit-value-box" }
const _hoisted_23 = { class: "period-value" }
const _hoisted_24 = { class: "period-unit" }
const _hoisted_25 = {
  key: 1,
  class: "period-value no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wago-energy-stats mb-3", { 'dark-mode': _ctx.isDarkMode }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('components.assetDetails.wagoStats.energyActive')), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.activeRelativeTime), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.stats.active.current !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.formatNumber(_ctx.stats.active.current)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_8, "—")),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.stats.active.unit), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('components.assetDetails.wagoStats.energyReactive')), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.reactiveRelativeTime), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.stats.reactive.current !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.formatNumber(_ctx.stats.reactive.current)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_16, "—")),
          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.stats.reactive.unit), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.periodCards, (period, idx) => {
        return (_openBlock(), _createElementBlock("div", {
          key: period.key,
          class: _normalizeClass(["col-6 stats-period-cell", { 'border-end-subtle': idx % 2 === 0 }])
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_20, _toDisplayString(period.label), 1),
              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.activeRelativeTime || '—'), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              (period.value !== null)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[0] || (_cache[0] = _createTextVNode(" +", -1)),
                      _createElementVNode("span", null, _toDisplayString(_ctx.formatNumber(period.value)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.stats.active.unit), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_25, " — "))
            ])
          ])
        ], 2))
      }), 128))
    ])
  ], 2))
}